import { forEach, isNil, toUpper, trim } from 'lodash';
import { Municipality } from '@app/shared/services/api/municipality.service';
import { Region } from '@app/shared/services/api/regions.service';

export class StringUtility {
  public static removeLeadingZeroes(s: string): string {
    return s?.replace(/^0+/, '');
  }

  public static isAlphabetKeyCode(keyCode: number): boolean {
    return keyCode >= 65 && keyCode <= 90;
  }

  public static hasAnyMatchInArray(s: string[], t: string[]): boolean {
    return s.some((s1) => t.includes(s1));
  }

  public static formatObisId(obisId: string): string {
    return obisId.split(':')[1];
  }

  public static removeObisIdPeriods(obisId: string): string {
    return obisId.split(':')[1].replace(/\./g, '');
  }

  public static replaceAll(replaceString: string, pattern: string, replaceWith: string): string {
    return replaceString.split(pattern).join(replaceWith);
  }

  public static removeTrailingSpaces(string: string): string {
    let result = '';
    const splitString = string.split(' ');
    forEach(splitString, (str) => {
      const ss = str.trim().replace(/(\r\n|\n|\r)/gm, ' ');
      if (!isNil(ss) && ss !== '') {
        result = result + ss + ' ';
      }
    });
    return result.trim();
  }

  public static areStringsIdentical(s1: string, s2: string): boolean {
    return toUpper(trim(s1)) === toUpper(trim(s2));
  }

  public static isArrayValuesEqual(s1: string[]) {
    return s1.every((val, i, arr) => val === arr[0] || '');
  }

  public static getDate(date: string): Date {
    let dateArray: string[];
    if (date.indexOf('T') > -1) {
      dateArray = date.toString().split('T');
      dateArray = dateArray[0].toString().split('-');
      return new Date(Number(dateArray[0]), Number(dateArray[1]) - 1, Number(dateArray[2]));
    } else {
      dateArray = date.toString().split('.');
      return new Date(Number(dateArray[2]), Number(dateArray[1]) - 1, Number(dateArray[0]));
    }
  }

  public static getNumberPlaceholder(length: number, decimal: number): string {
    let placeholderText = '';
    let i = 1;
    let x = 0;
    while (i <= length) {
      if (x === 3) {
        placeholderText += ' .';
        x = 0;
      }
      placeholderText += ' -';
      i++;
      x++;
    }
    placeholderText = placeholderText.split('').reverse().join('');
    let comma = false;
    i = 1;

    while (i <= decimal) {
      if (!comma) {
        placeholderText += ',';
        comma = true;
      }
      placeholderText += ' -';
      i++;
    }
    return placeholderText;
  }

  public static replaceTranslation(translate: string, counts: string[]): string {
    for (let i = 0; i < counts.length; i++) {
      translate = translate.split(`{${i}}`).join(counts[i]);
    }
    return translate;
  }

  public static getLocationName(data: Municipality | Region): string {
    if ((data as Municipality).municipalityKey) {
      return data.name + ' (' + (data as Municipality).municipalityKey + ')';
    } else {
      return data.name;
    }
  }

  public static addSpacing(length: number) {
    return length > 5 ? '   ' : '     ';
  }

  public static addSpacingDifference(length1: number, length2: number) {
    const dif = length1 - length2;
    let space = '';
    let i = 0;
    while (i < dif) {
      space += '  ';
      i++;
    }
    return space;
  }

  public static formatDecimalPlacesByValue(value: number): string {
    if (value === null || value === undefined) {
      return '';
    }

    const Globalize = require('globalize');
    let decimal = 0;
    if (value < 1) {
      decimal = 3;
    } else {
      decimal = 2;
    }
    const formatter = Globalize.numberFormatter({ maximumFractionDigits: decimal, minimumFractionDigits: decimal });
    return formatter(typeof value === 'string' ? parseInt(value, 10) : value);
  }
}
